<template>
    <div class="mywealth-container">
        <!-- HEADER -->
        <div class="header">
            <div class="back-container" @click="back">
                <img class="back" :src="Back" alt="Back">
                <span class="title">سرمایه من</span>
            </div>

            <p>موجودی</p>
            <h2 v-if="Credit">{{ Credit | comma }} تومان</h2>
            <h2 v-else>0 تومان</h2>
        </div>

        <div class="btn-container">
            <p v-if="lastRec">آخرین واریز به حساب مبلغ {{ lastRec.Amount | comma }} تومان در تاریخ {{ lastRec.Created_at | moment }} انجام گردیده است.</p>
            <!-- <button class="btn btn-light btn-right" @click="CardPopUp">سرمایه گذاری</button> -->
            <!-- <button class="btn btn-light btn-left" @click="RecordsPopUp">مشاهده سوابق کامل</button> -->

            <button @click="AddCreditPopUp" class="btn btn-light btn-right">سرمایه گذاری</button>
            <button @click="CreditRecordsPopUp" class="btn btn-light btn-left">مشاهده سوابق کامل</button>
        </div>
        
        <!-- 
        <div class="footer-desc row">
            <span class="titles" :class="{ 'active' : Type == 'gift' }" @click="() => { Type = 'gift' }">کارت‌های هدیه من</span>
            <span class="titles" :class="{ 'active' : Type == 'award' }" @click="() => { Type = 'gift' }">کارت‌های جایزه من</span>
            // <span class="titles" :class="{ 'active' : Type == 'award' }" @click="() => { Type = 'award' }">کارت‌های جایزه من</span>

            <div class="inner-desc" v-if="userCards.length == 0">
                <span>شما در حال حاضر هیچ کارت {{ Type == 'gift' ? 'هدیه‌ای' : 'جایزه‌ای' }} وجود ندارید.</span>
            </div>
            <carousel 
                :per-page="1" 
                :autoplay="true"
                :loop="true"
                :autoplayTimeout="3000"
                :paginationEnabled="false"
                class="carousel-container" v-else
            >
                // @click="CheckActivate( card.CardItem.Price)"
                <slide
                    v-for="(card, index) in userCards" :key="index"
                >
                    <router-link
                        tag="div"
                        class="slide-container"
                        :style="{ 'background-image': 'url(' +  URL + '/' + card.CardItem.Cover + ')' }"
                        :to="{
                            name: Type == 'gift' ? 'ActivateGift' : 'ActivateCard',
                            params: {
                                id: card.CardItem._id,
                                price: card.CardItem.Price
                            }
                        }"
                    ></router-link>
                </slide>
            </carousel>
        </div> 
        -->

        <!-- Modals -->
        <!-- <cards-modal :list="list" :SubmitCard="SubmitCard" :type="Type"/> -->
        <credit-records-modal :list="recordsList"/>
        <add-credit-modal :submitRequest="submitRequest"/>
    </div>
</template>

<script>
import Back from '@/assets/images/mywealth/back.png';
// import Card from '@/assets/images/mywealth/test_card.png';

import { getRequest, postRequest, APP_API_URL } from '@/utils/libs/api-request';
import Cookies from 'js-cookie';

// import CardsModal from '@/components/modals/cards_modal';
// import RecordsModal from '@/components/modals/records_modal';
import CreditRecordsModal from '@/components/modals/credit_records_modal';
import AddCreditModal from '@/components/modals/add_credit_modal';

import moment from 'moment-jalaali';
// import { Carousel, Slide } from 'vue-carousel';

export default {
    name: 'MyWealth',
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },
    data() {
        return {
            Back: Back,
            prevRoute: {},
            URL: APP_API_URL(),

            Credit: 0,
            // Type: 'gift',
            lastRec: {},
            list: [],
            recordsList: [],
            userCards: []
        }
    },
    components: {
        AddCreditModal,
        CreditRecordsModal,
        // Carousel,
        // Slide,
        // CardsModal,
        // RecordsModal
    },
    filters: {
        // will show the date like 'Jun 24th 2020'
        moment: (date) => {
            return moment(date).format('jDD/jMMMM/jYYYY');
        }
    },
    // watch: {
    //     Type: {
    //         handler: function() {
    //             this.GetUser()
    //             this.GetAll()
    //         },
    //         immediate: true
    //     }
    // },
    mounted() {
        this.GetUser()
    },
    methods: {
        submitRequest(value) {
            if(value <= 0) {
                this.$modal.show('dialog', {
                    title: 'هشدار!',
                    text: 'مقدار عددی نامعتبر (صفر یا منفی) می‌باشد',
                    buttons: [
                        {
                            title: 'تایید',
                            default: true,
                        }
                    ]
                });
                
                return;
            }

            postRequest('/users/add-credit', {
                amount: +value
            })
                .then((rsp) => {
                    // this.GetUser()
                    document.location = rsp['data'].response;
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' });
                        }
                    }
                });
        },
        // get list of all cards
        GetUser() {
            getRequest('/users/user')
                .then(rsp => {
                    // response
                    let data = rsp['data'];
                    this.Credit = data.Credit;

                    // this.userCards = data.Cards.filter(card => card.CardItem.Type == this.Type && !card.Status)
                    this.recordsList = data.CreditRecord;
                    this.lastRec = this.recordsList[this.recordsList.length - 1]
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' });
                        }
                    }
                });
        },
        // get list of all cards
        // GetAll() {
        //     getRequest('/cards/find-all', { type: this.Type })
        //         .then(rsp => {
        //             // response
        //             this.list = rsp['data']
        //         })
        //         .catch(err => {
        //             // check auth
        //             if (err.response) {
        //                 if (err.response.status == 401) {
        //                     Cookies.remove('access_cookie');
        //                     this.$router.push({ name: 'Login' });
        //                 }
        //             }
        //         });
        // },
        // CardPopUp() {
        //     this.$modal.show('cards-modal');
        // },
        // RecordsPopUp() {
        //     this.$modal.show('records-modal');
        // },
        CreditRecordsPopUp() {
            this.$modal.show('credit-records-modal');
        },
        AddCreditPopUp() {
            this.$modal.show('add-credit-modal');
        },
        // SubmitCard(id) {
        //     if (!Cookies.get('access_cookie')) {
        //         this.$router.push({ name: 'Login' });
        //     } else {
        //         postRequest('/cards/add-card', { 
        //             id: id
        //         })
        //             .then(() => {
        //                 // response
        //                 this.GetUser()
        //             })
        //             .catch(err => {
        //                 // check auth
        //                 if (err.response) {
        //                     if (err.response.status == 401) {
        //                         Cookies.remove('access_cookie');
        //                         this.$router.push({ name: 'Login' });
        //                     }
        //                 }
        //             });
        //     }
        // },
        back() {
            if(this.prevRoute.name) {
                this.$router.go(-1)
            } else {
                this.$router.push({ name: 'Khanesh' })
            }
        }
    }
}
</script>

<style scoped>
/* ---------------------------------------- */
/* ---------------- GENERAL --------------- */
/* ---------------------------------------- */
.mywealth-container {
    min-height: 100vh;
    width: 100%;
    padding: 0 0 1pt;

    border-bottom-left-radius: 30pt;
    border-bottom-right-radius: 30pt;
    background-color: #f1f2f6;

    position: relative;
}

/* ---------------------------------------- */
/* ---------------- HEADER ---------------- */
/* ---------------------------------------- */
.mywealth-container .header {
    min-height: 40vh;
    width: 100%;

    border-bottom-left-radius: 5vh;
    border-bottom-right-radius: 5vh;
    background-color: #fff;

    position: relative;
    display: flex;
    flex-direction: column;
}
.mywealth-container .header p {
    margin: auto auto 0;
}
.mywealth-container .header h2 {
    margin: 1rem auto auto;
}
.mywealth-container .header .back-container {
    position: absolute;
    top: 10pt;
    right: 10pt;

    cursor: pointer;
}
.mywealth-container .header .back-container .title {
    margin-right: 10pt;
    font-weight: 500;
}
.mywealth-container .header .back-container .back {
    margin-top: 1pt;
}
.mywealth-container .header .back-container .title,
.mywealth-container .header .back-container .back {
    height: 20pt;
}

/* ---------------------------------------- */
/* ------------- LAST PAYMENT ------------- */
/* ----------------- BTNS ----------------- */
/* ---------------------------------------- */
.mywealth-container .last-payment {
    width: 100%;
    margin: 1rem auto;

    text-align: center;
    display: inline-block;
}
.mywealth-container .btn-container {
    display: flex;
    flex-wrap: wrap;

    padding-top: 1rem;
}
.mywealth-container .btn-container p {
    width: 100%;
    
    display: block; 
    text-align: center;
}
.mywealth-container .btn-right,
.mywealth-container .btn-left {
    width: 100pt;
    padding: 1rem 0;
    margin: 0 auto;

    font-size: 80%;
    font-weight: bold;
    border-radius: 10pt;

    border: 1px solid;
}
.mywealth-container .btn-left {
    color: #264864;
    border-color: #264864;
    box-shadow: 3px 3px 6px 0px #2648645f;
}
.mywealth-container .btn-right {
    color: #2ad85f;
    border-color: #2ad85f;
    box-shadow: 3px 3px 6px 0px #2ad85f5f;
}

/* ---------------------------------------- */
/* -------------- FOOTER DESC ------------- */
/* ---------------------------------------- */
.mywealth-container .footer-desc {
    min-height: 35vh;
    margin: 20pt 25pt 20pt 0;

    background-color: #115525;
    border-top-right-radius: 5vh;
    border-bottom-right-radius: 5vh;

    display: flex;
}
.mywealth-container .footer-desc .titles {
    height: 30pt;
    margin: 0 auto;
    padding: 7pt 0 0;

    cursor: pointer;

    font-size: 80%;
    color: #b9b9b9;
    border-top: 3px solid #115525;
}
.mywealth-container .footer-desc .active {
    color: #fefefe;
    border-top: 3px solid #faa21a;
}
.mywealth-container .footer-desc .inner-desc {
    height: calc(35vh - 60pt);
    width: calc(100% - 50pt);
    margin: -10pt auto auto;

    border: 1px solid #084019;
    border-radius: 10pt;
    box-shadow: inset 1px 1px 5px 2px #084019;

    display: flex;
}
.mywealth-container .footer-desc .inner-desc span {
    max-width: 115pt;
    margin: auto;

    font-size: 80%;
    color: #b9b9b998;

    text-align: center;
    display: inline-block;
}
@media (max-width: 576px) {
    .mywealth-container .btn-container p { 
        font-size: 75%;
    }
}
/* ---------------------------------------- */
/* --------------- CAROUSEL --------------- */
/* ---------------------------------------- */
.mywealth-container .carousel-container {
    height: calc(35vh - 60pt);
    width: 100%;

    direction: ltr;
    margin: -10pt auto auto;
}
.mywealth-container .slide-container {
    height: calc(35vh - 60pt);

    cursor: pointer;
    z-index: 10000;

    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}
</style>
